//@flow

import {
  OrderedMap,
} from 'immutable';

import {
  ReduceStore
} from 'flux/utils';

import Dispatcher from 'app/Dispatcher';
import {
  ActionTypes
} from './auth-actions';


// import jwt from 'jsonwebtoken';

class Store extends ReduceStore < Object > {
  constructor() {
    super(Dispatcher);
  }

  getInitialState(): Object {
    return OrderedMap();
  }

  reduce(state: Object, action: Object): Object {
    // console.log(action)
    switch (action.type) {
      case ActionTypes.SET_TOKEN:
        return state.withMutations(map => {
          map.set("token", action.token)
        })
      default:
        return state;
    }
  }
}

export default new Store();